import { BusEvent } from '@web/common';

export class AdminOrderChangedBusEvent extends BusEvent {}
